module.exports = __webpack_public_path__ + "img/Evolving_our_Employee_Resource_Groups.f4237cc3.jpg";